/**
 * Created by mongoose on 20/12/17.
 */
import { range, min as minLodash } from "lodash";
import constants from "./constants";

export function calculateSelectorsRange({
  showChildrenCount,
  occupantsMinAge,
  occupantsMaxValues,
  occupantsSelectorRange,
  fields,
}) {
  const selectorsRange = constants.OCCUPANTS_TYPE_ORDER.reduce((previous, type) => {
    const min = type === constants.OCCUPANTS_TYPE.ADULT ? 1 : 0;
    const max = occupantsMaxValues.get(type);

    return fields[type]
      ? {
          ...previous,
          [type]: occupantsSelectorRange[type] || range(min, max + 1, 1).map(value => value),
        }
      : previous;
  }, {});

  if (showChildrenCount) {
    const childrenOccupants = constants.OCCUPANTS_TYPE_ORDER.filter(
      type => type !== constants.OCCUPANTS_TYPE.SENIOR && type !== constants.OCCUPANTS_TYPE.ADULT
    );
    const min =
      minLodash(
        childrenOccupants.reduce((result, type) => {
          const data = occupantsMinAge.get(type);
          if (!isNaN(data)) {
            result = [...result, data];
          }
          return result;
        }, [])
      ) || 0;
    let max = childrenOccupants
      .map(type => occupantsMaxValues.get(type) || 0)
      .reduce((previous, current) => previous + current);

    /* Children count selector range */
    selectorsRange.childrenCount = {
      max,
      min: 0,
      range: range(0, max + 1, 1).map(value => value),
    };

    max = occupantsMinAge.get(constants.OCCUPANTS_TYPE.ADULT) - 1;

    selectorsRange.childrenAges = {
      max,
      min,
      range: range(min, max + 1, 1).map(value => value),
    };
  }
  return selectorsRange;
}
